import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * `.kv-grid` — the drawer's key/value block. `120px 1fr`, 13.5px. Ids, dates
 * and money pass `mono`; the balance/net line passes `strong`.
 */
function KvGrid({ rows }) {
	return (
		<dl className='tw:grid tw:grid-cols-[120px_1fr] tw:gap-x-4 tw:gap-y-2 tw:text-[13.5px]'>
			{rows.map((row) => (
				<React.Fragment key={row.label}>
					<dt className='tw:m-0 tw:font-medium tw:text-ink-2'>{row.label}</dt>
					<dd
						className={classnames(
							'tw:m-0 tw:text-ink-0',
							row.mono && 'tw:font-mono',
							row.strong && 'tw:font-semibold',
						)}
					>
						{row.value}
					</dd>
				</React.Fragment>
			))}
		</dl>
	);
}

KvGrid.propTypes = {
	rows: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.node,
			mono: PropTypes.bool,
			strong: PropTypes.bool,
		}),
	).isRequired,
};

export default KvGrid;
